<template>
  <div class="d-flex justify-space-between align-center">
    <div class="display-1 font-weight-bold">
      {{ moduleName }}
    </div>
    <div class="body-2">
      <v-breadcrumbs class="justify-end"
                     :items="breadcrumbs" divider=">"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    moduleName: {
      type: String,
      required: true,
    },
    breadcrumbs: {
      type: Array,
    },
  },
};
</script>
